import { faqData } from '@/mocks/home';

export default function FAQ() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">关于每日吃瓜，你可能想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-6"
            >
              <h3 className="text-base font-heading font-bold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded bg-primary-100 text-primary-600 text-xs font-bold shrink-0 mt-0.5">Q</span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}